import {DepartmentModel, LocationModel, SpecialtyModel} from './provider.model';
import {AddressModel} from './address.model';
import {Link} from './link.model';
import {PrivilegeModel} from './user-session.model';

export interface PerformerModel {
  id: string;
  links: Link[];
  address: AddressModel;
  accountId: string;
  firstName: string;
  lastName: string;
  performerId?: string;
  name: string;
  phoneNumber: string;
  medicalLicense: string;
  pharmacistNPI: string;
  deaNumber: string;
  specialties: Array<any>;
  gender: string;
  nationality: string;
  languages: string[];
  dateOfBirth: number;
  dateCreated: number;
  email: string;
  workNumber: string;
  workNumberExtension: string;
  userName: string;
  department: DepartmentModel;
  departmentResource: DepartmentModel;
  location: AddressModel;
  locations: AddressModel[];
  profileImage: string;
  performerImage?: string;
  providerImage?: string;
  teamMemberImg: string;
  role?: string;
  specialty?: string;
  appointments?: CareTeamAppointment;
  op?: string;
  privilege: PrivilegeModel;
}

export class CareTeamAppointment {
  data: any[];
  isLoaded: boolean;
  isLoading: boolean;
}

export class Performer {
  id: string;
  links: Link[];
  accountId: string;
  firstName: string;
  lastName: string;
  performerId?: string;
  name: string;
  phoneNumber: string;
  medicalLicense: string;
  pharmacistNPI: string;
  deaNumber: string;
  specialties: Array<any>;
  gender: string;
  nationality: string;
  languages: string[];
  dateOfBirth: number;
  email: string;
  workNumber: string;
  workNumberExtension: string;
  userName: string;
  department: Department = new Department(); // { id: number;  name: string}
  departmentResource: Department;
  location: AddressModel;
  locations: AddressModel[];
  profileImage: string;
  performerImage?: string;
  providerImage?: string;
  teamMemberImg: string;
  role?: string;
  specialty?: string;
  appointments?: CareTeamAppointment;
  op?: string;
}

export class UpdatePerformer {
  id?: string;
  updateProfileInfo: UpdateProfileInfo = new UpdateProfileInfo();
  updateAccountInfo: UpdateAccountInfo = new UpdateAccountInfo();
  updateLocations: UpdateLocations = new UpdateLocations();
  // updateNotifications: updateNotifications = new updateNotifications();
  links?: any[];
}

class UpdateProfileInfo {
  firstName: string;
  lastName: string;
  medicalLicenseId: string;
  pharmacistNPI: string;
  deaNumber: string;
  organizationId: string;
  organizationName: string;
  department: number;
  departmentId: string;
  departmentObj: DepartmentModel;
  specialties: number[];
  specialtiesObj: SpecialtyModel[];
  dateOfBirth: string;
  gender: string;
  nationality: string;
  languages: Array<string>;
  profileImage: string;
}

class UpdateAccountInfo {
  emailAddress: string;
  userName: string;
  phoneNumber: string;
  workNumber: string;
  workNumberExt: string;
  firstName?: string;
  lastName?: string;
  privilege: PrivilegeModel;
  privilegeId: string;
  employeeId: string;
  secondaryOrganizations: string;
}

class UpdateLocations {
  locations: Array<LocationModel> = [];
}

// class updateNotifications {
// notifyInstant: boolean;
// notifyComments: boolean;
// }

// export class SearchSpecialtiesModel {
//   id?: string;
//   private: boolean;
//   serviceTypes: number[];
//   name?: string;
//   links?: Link[];
//   isDeleted?: boolean;
//   description?: string;
// }

export class Department {
  description: string;
  id: string;
  links?: any[];
  name: string;
  organizationId: string;
  organizationName: string;
}
